import React, { useState } from 'react'
import Badge from '@material-ui/core/Badge';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { useSelector, useDispatch } from 'react-redux';
import withReducer from 'app/store/withReducer';
import reducer from './store';

import { selectNotifications } from './store/dataSlice';
// import { toggleNotificationPanel } from './store/stateSlice';
import NotificationPanel from './NotificationPanel'

function NotificationPanelToggleButton(props) {
  const notifications = useSelector(selectNotifications);
  const [isOpen, setisOpen] = useState(false)

  // const dispatch = useDispatch();

  function handleDialoge() {
    setisOpen(true)
  }
  function handleClose(){
    setisOpen(false)
  }

  return (
    <>
      <IconButton className="w-40 h-40" onClick={handleDialoge}>
        <Badge color="secondary" variant="dot" invisible={notifications.length === 0}>
          {props.children}
        </Badge>
      </IconButton>
      <NotificationPanel isOpen={isOpen} handleClose={handleClose} />
    </>
  );
}

NotificationPanelToggleButton.defaultProps = {
  children: <Icon>notifications</Icon>,
};

export default withReducer('notificationPanel', reducer)(NotificationPanelToggleButton);
